import CollectivePurchasingListCom from './collective-purchasing-list/collective-purchasing-list.vue';
import CollectivePurchasingDetailCom from './collective-purchasing-detail/collective-purchasing-detail.vue';
import CollectivePurchasingSignUpCom from './sign-up/sign-up.vue';

export default [
  {
    path: 'list',
    name: 'collectivePurchasingList',
    component: CollectivePurchasingListCom
  },
  {
    path: 'detail',
    name: 'collectivePurchasingDetail',
    component: CollectivePurchasingDetailCom,
    meta: {
      title: '项目详情',
      breadCrumbShowIndexArr: [0, 1, 3]
    }
  },
  {
    path: 'sign-up',
    name: 'collectivePurchasingSignUp',
    component: CollectivePurchasingSignUpCom,
    meta: {
      title: '申请报名',
      breadCrumbShowIndexArr: [0, 1, 3]
    }
  }
];
